import { useCallback } from "react";
import SwivuModal from "./SwivuModal.jsx";
import SwivuEntityFinderPopup from "../../../bryntum-lib/editors/entityFinder/SwivuEntityFinderPopup.jsx";

const SwivuEntityFinder = ({
  context,
  record,
  onClose,
  isShow,
  editorInstance
}) => {
  const onShowHandler = useCallback(
    (editor, otherParams = {}) => {
      editor.project = context.project;
      const { onEntitiesSelected, isOnlyFinder } = record;
      editor.editRecord(record, context, { ...otherParams, onEntitiesSelected, isOnlyFinder });
      editorInstance.editorRef = editor;
    },
    [record, context, editorInstance]
  );
  return (
    <SwivuModal
      widgetType={SwivuEntityFinderPopup.type}
      isShow={isShow}
      onHide={onClose}
      onShow={onShowHandler}
    />
  );
};

export default SwivuEntityFinder;
